import React, { useEffect, useState } from "react"
import Button from "components/Button"
import Toast from "components/Toast"
import SurveyComponent from "pages/RMO/components/cancerTemplate/Template"
import defaultSurveyConfig from "pages/RMO/components/cancerTemplateForm/template"
import "./MrdApprovalRequest.scss"
import { savePendingApprovalRequest } from "core/services/api/mrdService"
import { useHistory, useLocation } from "react-router-dom"
import { getTemplatesByType } from "core/services/api/patientDiagnosisService"

export default function MrdApprovalRequest() {

  const location = useLocation()
  const history = useHistory()

  const [isApproved, setIsApproved] = useState(false)
  const [isRejected, setIsRejected] = useState(false)
  const [requestObj, setRequestObj] = useState<any>({})
  const [data, setData] = useState<any>({})
  const [raiseRequestJson, setRaiseRequestJson] = useState<any>({})
  const [isHardCopy, setIsHardCopy] = useState<any>(false)
  const [hardCopySelection, setHardCopySelection] = useState<boolean>(false)

  useEffect(() => {
    let tempJson: any = {}
    getTemplatesByType("COMMON")
      .then((res: any) => {
        tempJson = res?.find((e: any) => e?.subType === "Requisition Form For File Reference")?.data[0]?.json || {}
        // tempJson["pages"][0]["readOnly"] = true
        tempJson["showNavigationButtons"] = "none"
        setRaiseRequestJson(tempJson)
      })
      .catch((err: any) => console.log(err?.message))
  }, [])

  useEffect(() => {
    setRequestObj(location?.state?.selected)
    setData(location?.state?.selected?.formData)
  }, [])

  const updateCallback = (dataObj: any, survey: any) => {
    setData({ ...data, ...dataObj })
  }

  const handleSubmit = (e: any) => {
    if (e.target?.innerText == "Approve") {
      if (isHardCopy === null) {
        setHardCopySelection(true)
      } else {
        //API Call for approve pending mrd request
        savePendingApprovalRequest("approve", requestObj.id, data)
          .then((res: any) => {
            setIsApproved(true)
          })
          .catch((err: any) => console.log(err?.message))
      }
    }
    if (e.target?.innerText == "Reject") {
      //API Call for reject pending mrd request
      savePendingApprovalRequest("reject", requestObj.id, data)
        .then((res: any) => {
          setIsRejected(true)
        })
        .catch((err: any) => console.log(err?.message))
    }
  }

  return (
    <div className="consultant-approval-request-wrapper">
      {isApproved ? (
        <Toast
          textMessage={`Approved Successfully`}
          type="success"
          onCloseText={"Close"}
          onClose={() => {
            setIsApproved(false)
            history.push("/mrdPendingApprovalRequests")
          }}>
        </Toast>
      ) : isRejected ? (
        <Toast
          textMessage={`Rejected Successfully`}
          type="success"
          onCloseText={"Close"}
          onClose={() => {
            setIsRejected(false)
            history.push("/mrdPendingApprovalRequests")
          }}>
        </Toast>
      ) : hardCopySelection ? (
        <Toast
          textMessage={`Select document request format`}
          type="warning"
          onCloseText={"Close"}
          onClose={() => setHardCopySelection(false)}>
        </Toast>
      ) : null}
      <div className="heading-container">
        <div
          className="approval-back-image"
          onClick={() => {
            history.push("/mrdPendingApprovalRequests")
          }}
        >
          <img
            src="../../assets/images/back-icon.svg"
            height={"60px"}
            width={"60px"}
            alt="back button"
            className="back_button"

          />
          <span className="approval-request-text">MRD Pending Approvals</span>
        </div>
      </div>
      <div className="mrd-raise-request-content">
        < SurveyComponent
          css={defaultSurveyConfig.defaultSurveyCSS}
          data={data}
          json={raiseRequestJson}
          updateFlag={updateCallback}
          onComplete={(survey: any) => {
            console.log(survey.data)
          }}
        />
      </div>
      <div className="checkbox-container">
        <label htmlFor="hard-copy">Request Hard Copy*</label>
        <input
          id="hard-copy"
          className="verify-checkbox"
          type="checkbox"
          checked={isHardCopy}
          onChange={(e: any) => setIsHardCopy(e.target.checked)}
        />
      </div>
      <div className="approve-reject-container">
        <div className="button-alignment">
          <div>
            <Button
              text="Approve"
              type="submit"
              id="mrd-approve"
              onClick={(e) => handleSubmit(e)}
            // disabled={pendingApprovalResult?.status === "APPROVED" || pendingApprovalResult?.status === "REJECTED" ? true : false}
            />

          </div>
          <div>
            <Button
              text="Reject"
              type="submit"
              outline={true}
              id="mrd-approve-submit"
              onClick={(e) => handleSubmit(e)}
            // disabled={pendingApprovalResult?.status === "APPROVED" || pendingApprovalResult?.status === "REJECTED" ? true : false}
            />
          </div>
        </div>
      </div>
      {/* </form> */}
    </div>
  )
}
